export const calcMaxDimensionsMobile = (width: number, height: number): { maxWidth: number; maxHeight: number } => {
  return { maxWidth: 360 * (width / height), maxHeight: 360 };
};

export const calcMaxDimensionsDesktop = (width: number, height: number): { maxWidth: number; maxHeight: number } => {
  const aspectRatio = width / height;

  if (aspectRatio >= 672 / 600) {
    return { maxWidth: 672, maxHeight: (1 / aspectRatio) * 672 };
  } else {
    return { maxWidth: aspectRatio * 600, maxHeight: 600 };
  }
};
